export default __webpack_public_path__ + "static/media/h7.0fc673a7.jpg";